import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { getLocaleFormatDate } from '../../../helpers/helpers';

interface ITick {
  language: string;
  payload: { value: string };
  x: number;
  y: number;
}

const Tick: FC<ITick> = ({ language, payload: { value }, x, y }) => {
  const theme = useTheme();

  return (
    <text fill={theme.colors.neutral.primary[80]} strokeWidth={1} textAnchor="middle">
      {!['ADAPT', 'PULSE'].includes(value) ? (
        <tspan x={x} y={y + 5}>
          {getLocaleFormatDate(value, language)}
        </tspan>
      ) : (
        <tspan x={x} y={y - 5}>
          {value}
        </tspan>
      )}
    </text>
  );
};

export default Tick;
